import { ADMIN_SERFF_PLAN_LOAD_STATUS_ACTION_TYPES } from '../../../constants/actionTypes/adminSerffStatusActionTypes';

interface IAction {
  type: string;
  payload?: any;
}

export interface IFilterOption {
    text: string;
    value: string;
  }
  
export interface IFilterOptions {
    issuers: IFilterOption[];
  }

interface IFilterState {
  filters: IFilterOptions;
}

export const INITIAL_STATE: IFilterState = {
    filters: {
        issuers: [],
    },
};


export default (state = INITIAL_STATE, action: IAction): IFilterState => {
    switch (action?.type) {
        case ADMIN_SERFF_PLAN_LOAD_STATUS_ACTION_TYPES.SET_FILTER_OPTIONS: {
          
            return {
                ...state,
                filters: { issuers: action.payload },
            };
        }

        default:
            return state;
    }
};
